import { useState, useEffect } from "react";
import { Link, Route, Routes, useNavigate, useParams } from "react-router-dom";
import "./../styles/Blog.css";
import axios from "axios";
import * as Constants from "../constants/Constants";
 
const Blog = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState("All");

    useEffect(() => {
        axios
            // .get("http://127.0.0.1:8000/api/blogs")
            .get(`${Constants.REACT_APP_API_URL}api/blogs`)
            .then((response) => {
                setBlogs(response.data.data);
            })
            .catch((error) => {
                console.error("Failed to fetch blogs:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    // Get unique categories for the sidebar
    const categories = [
        "All",
        ...new Set(blogs.map((blog) => blog.category_name)),
    ];

    // Filter blogs by active category
    const filteredBlogs =
        activeCategory === "All"
            ? blogs
            : blogs.filter((blog) => blog.category_name === activeCategory);

    return (
        <div className="blog-container">
            <main className="blog-content">
                <aside className="sidebar">
                    <div className="categories">
                        <h3>Categories</h3>
                        <ul>
                            {categories.map((category) => (
                                <li
                                    key={category}
                                    className={
                                        activeCategory === category
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() => setActiveCategory(category)}
                                >
                                    {category}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* <div className="newsletter">
            <h3>Subscribe to our Newsletter</h3>
            <form onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Your email address" />
              <button type="submit">Subscribe</button>
            </form>
          </div> */}
                </aside>

                <section className="posts-section">
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <>
                                    <h2>Latest Articles</h2>
                                    {loading ? (
                                        <div>Loading...</div>
                                    ) : (
                                        <div className="posts-grid">
                                            {filteredBlogs.map((blog) => (
                                                <article
                                                    key={blog.id}
                                                    className="post-card"
                                                >
                                                    <div className="post-meta">
                                                        <span className="category">
                                                            {blog.category_name}
                                                        </span>
                                                        <span className="date">
                                                            {new Date(
                                                                blog.created_at
                                                            ).toLocaleDateString(
                                                                "en-US",
                                                                {
                                                                    year: "numeric",
                                                                    month: "long",
                                                                    day: "numeric",
                                                                }
                                                            )}
                                                        </span>
                                                    </div>
                                                    <h3>{blog.title}</h3>
                                                    <p className="excerpt">
                                                        {blog.excerpt}
                                                    </p>
                                                    <div className="post-footer">
                                                        <span className="author">
                                                            By {blog.author}
                                                        </span>
                                                        <Link
                                                            to={`/blog/post/${blog.id}`}
                                                            className="read-more"
                                                        >
                                                            Read More
                                                        </Link>
                                                    </div>
                                                </article>
                                            ))}
                                        </div>
                                    )}
                                </>
                            }
                        />
                        <Route path="/post/:id" element={<PostDetail />} />
                    </Routes>
                </section>
            </main>
        </div>
    );
};

const PostDetail = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`${Constants.REACT_APP_API_URL}api/blogs/${id}`)
            .then((response) => {
                setPost(response.data.data);
            })
            .catch((error) => {
                console.error("Failed to fetch post:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    if (loading) return <div>Loading...</div>;
    if (!post) return <div>Post not found</div>;
    return (
        <div className="post-detail">
            <button onClick={() => navigate("/blog")} className="back-button">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
                {/* Back to all posts */}
            </button>
            <article>
                <div className="post-meta">
                    <span className="category">{post.category_name}</span>
                    <span className="date">
                        {new Date(post.created_at).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                    </span>
                </div>
                <h1>{post.title}</h1>
                <p className="excerpt">{post.excerpt}</p>
                <div className="author-info">
                    <span>By {post.author}</span>
                </div>
                {post.image_url && (
                    <div className="post-image-container">
                        <img
                            src={post.image_url}
                            alt={post.title}
                            className="post-image"
                            onError={(e) => {
                                e.target.style.display = "none"; // Hide if image fails to load
                            }}
                        />
                    </div>
                )}
                <div
                    className="post-content"
                    dangerouslySetInnerHTML={{ __html: post.content }}
                />
            </article>
        </div>
    );
};

export default Blog;
